import styled, {css, keyframes} from "styled-components";

const enlargingSliceFillKeyframes = keyframes`
    0% {
        transform: scale(1) translateY(0);
    }
    100% {
        transform: scale(1.8) translateY(10%);
    }
`;
const disappearingEnlargedSliceKeyframes = keyframes`
    0% {
        opacity: 1;
    }
    100% {
        opacity: 0;
    }
`;

/**
 * The formula for rotating the svg.
 * Terms:
 * -90deg (stroke starts from the horizontal radius going from center to the right. 90deg offset changes it to vertical from center going up)
 * -(360*N)/2 (divides 360 deg to N prizes to find the degress of one slice, divide by 2 to offset half of the slice). Can be optimized to 180/N
 * 
 * Resulting formula: - 90 - 180/N
 */
/**
 * The formula for the stroke-dasharray
 * The circle is defined with a 32 radius (not px, svg units, it is relative to the viewBox, so it scales)
 * So the circumference of the circle is 2*Math.PI*32 = 201.06192982974676
 * Divide this by N, number of Slices to find the stroke dash length. The second parameter can be anything greater to 2*Math.PI*32 - 2*Math.PI*32/N. So I just leave it 200.
 */

export const SliceFillDefaultBox = styled.div<{
    animate: boolean;
    numberOfSlices: number;
    enlarge?: boolean; 
}>`
    position: absolute;
    width: 100%;
    height: 100%;
    /** z-index is needed because otherwise the green shadow from the 2 lines will overlap the slice */
    z-index: 1;
    ${({animate, enlarge}) => (enlarge && animate) ? css`
        animation: ${enlargingSliceFillKeyframes} 0.4s ease 0.2s backwards, ${disappearingEnlargedSliceKeyframes} 0.4s ease 0.2s forwards;
    ` : null}
    filter: drop-shadow(0px 4px 12px #7FF800);
    /* Otherwise it creates some horizontal scroll */
    overflow: clip;
    svg {
        transform: rotate(-${props => 90 + 180/props.numberOfSlices}deg);
        background: transparent;
        border-radius: 50%;
        display: block;
    }
    circle {
        fill: transparent;
        /* TODO: WheelOfJackpotbet: Winning slice color highlight */
        stroke: ${({animate}) => animate ? "#FFFFFF" : "transparent"};
        stroke-width: 64;
        stroke-dasharray: ${props => 201.06193/props.numberOfSlices}, 200;
        transition: stroke 0.2s ease-in 0.1s;
    }

    &.blurred {
        filter: blur(1px);
    }
`;